<template>
  <Dialog v-model:visible="visible" modal header="ویرایس حساب کاربری" :style="{ width: '80rem' }">
    <div class="card pb-0" v-if="loading">
      <div class="grid">
        <div class="col-12 md:col-6">
          <div class="flex align-items-center gap-3 mb-3">
            <label for="name" class="w-6rem">نام</label>
            <InputText v-model="currentData.first_name" id="first_name" class="flex-auto" autocomplete="off" />
          </div>
        </div>
        <div class="col-12 md:col-6">
          <div class="flex align-items-center gap-3 mb-3">
            <label for="name" class="w-6rem">نام خانوادگی</label>
            <InputText v-model="currentData.last_name" id="last_name" class="flex-auto" autocomplete="off" />
          </div>
        </div>
        <div class="col-12 md:col-6">
          <div class="flex align-items-center gap-3 mb-3">
            <label for="email" class="w-6rem">ایمیل</label>
            <InputText v-model="currentData.email" id="email" class="flex-auto" autocomplete="off" />
          </div>
        </div>
        <div class="col-12 md:col-6">
          <div class="flex align-items-center gap-3 mb-3">
            <label for="mobile" class="w-6rem">شماره موبایل</label>
            <InputText v-model="currentData.mobile" id="mobile" class="flex-auto" autocomplete="off" />
          </div>
        </div>
        <div class="col-12 md:col-6">
          <div class="flex align-items-center gap-3 mb-3">
            <label for="phone" class="w-6rem">شماره تلفن</label>
            <InputText v-model="currentData.phone" id="phone" class="flex-auto" autocomplete="off" />
          </div>
        </div>
        <div class="col-12 md:col-6">
          <div class="flex align-items-center gap-3 mb-3">
            <label for="national_code" class="w-6rem">کد ملی</label>
            <InputText v-model="currentData.national_code" id="national_code" class="flex-auto" autocomplete="off" />
          </div>
        </div>
        <div class="col-12 md:col-6">
          <div class="flex align-items-center gap-3 mb-3">
            <label for="password" class="w-6rem">رمز عبور</label>
            <InputText type="password" v-model="currentData.password" id="code" class="flex-auto" autocomplete="off" />
          </div>
          <div class="flex align-items-center gap-3 mb-3">
            <p v-if="actionType === 'edit'" class="text-red-500 text-sm p-0 m-0 col-12">
              در صورتی که نیاز به تغییر رمز عبور ندارید خالی بگذارید!
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-content-end gap-2">
      <Button type="button" label="انصراف" severity="secondary" @click="visible = false"></Button>
      <Button type="button" label="ذخیره" @click="saveData"></Button>
    </div>
  </Dialog>
</template>

<script setup>
import { ref } from 'vue';
import { AdminService } from '@/service/AdminService';
import emitter from '@/utils/eventBus';
import SelectInput from '@/components/Global/SelectInput.vue';
const AdminServiceItem = ref(new AdminService());
const currentData = ref({});
const visible = ref(false);
const loading = ref(true);
const props = defineProps({
  prevData: {
    default: () => {
      return {};
    },
    type: Object,
    required: false
  },
  actionType: {
    type: String,
    required: true
  }
});

const saveData = () => {
  console.log(currentData.value);
  AdminServiceItem.value
    .editAdmin(currentData.value.id, currentData.value)
    .then(() => {
      emitter.emit('toast', { type: 'success', message: 'مدیر با موفقیت ویرایش شد' });
      visible.value = false;
      emitter.emit('refresh-table-for-admins');
    })
    .catch((error) => {
      emitter.emit('toast-axios', error);
    });
};
const toggleModal = () => {
  visible.value = !visible.value;
  loading.value = true;
  currentData.value = JSON.parse(localStorage.getItem('user_credentials'));
  AdminServiceItem.value
    .getAdmin(currentData.value.id)
    .then((data) => {
      Object.assign(currentData.value, data.data.data);
      currentData.value.password = null;
    })
    .catch((error) => {
      emitter.emit('toast-axios', error);
    });
};
defineExpose({
  toggleModal
});
</script>
